import React from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "../Components/Sidebar/Sidebar.jsx";
import AddProduct from "../Components/AddProduct/AddProduct.jsx";
import ListProduct from "../Components/ListProduct/ListProduct.jsx";
import Orders from "../Components/Orders/Orders.jsx";
import CreateAdmin from "../Components/CreateAdmin/CreateAdmin.jsx";
import NewsletterSubscribers from "../Components/NewsletterSubscribers/NewsletterSubscribers.jsx";
import Reports from "../Components/Reports/Reports.jsx";
import DatabaseBackup from "../Components/DatabaseBackup/DatabaseBackup.jsx";
import "./CSS/Admin.css";

const Admin = () => {
  return (
    <div className="admin-container">
      <div className="admin-sidebar">
        <Sidebar />
      </div>
      <div className="admin-main-content">
        <Routes>
          <Route path="addproduct" element={<AddProduct />} />
          <Route path="listproduct" element={<ListProduct />} />
          <Route path="orders" element={<Orders />} />
          <Route path="newsletter" element={<NewsletterSubscribers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="createadmin" element={<CreateAdmin />} />
          <Route path="database-backup" element={<DatabaseBackup />} />
          {/* Add a default route for the admin dashboard */}
          <Route index element={<ListProduct />} />
        </Routes>
      </div>
    </div>
  );
};

export default Admin;
